// extracted by mini-css-extract-plugin
module.exports = {"stats":"_1PRSc","active":"_3lpLt","resetGenerationCounterBtn":"_9i8gP"};